import React, {useEffect} from "react";
import Container from 'react-bootstrap/Container';
import '../Lg.css';
import {TildaB} from "./common/TildaB";
import {logPageOpened} from "../../model/utils";
import {
    calcMotivationForNextLm,
    calcNameOfConcert,
    calcNectLmUrl,
    calcNextLmButtonName, calculateShortPageUrlNew,
    calcWhere,
    registerClick
} from "./common/LgHelper";
import {appdata} from "../../../logic_tmp/appdata/AppData";


export function LmFooter() {
    appdata.viewType = "LeadMagnetPage"
    useEffect(() => {
        logPageOpened(appdata.parentPath,appdata.viewType)
    }, []);
    return (<div>
        <Container>
            <TildaB>
                <span
                    className="normal">Это был фрагмент из концерта "{calcNameOfConcert(appdata)}"</span>
            </TildaB>
            <TildaB>
                <span className="normal">Мы собираемся организовать этот концерт в </span>
                <strong><span><strong
                    className="normal">{calcWhere(appdata)}.</strong></span></strong>
            </TildaB>
            <TildaB>
                <span className="normal">{calcMotivationForNextLm(appdata)}</span>
            </TildaB>
            <TildaB>
                <a id = "toNextLm" onClick={()=>registerClick(appdata, "NextLm", appdata.nextLmKey,"LeadMagnetPage")} href={calcNectLmUrl(appdata)} target="_parent"
                   className="myButton">{calcNextLmButtonName(appdata)}</a>
            </TildaB>
            <TildaB>
                <span className="normal">Нажмите на кнопку ниже, чтобы узнать больше об этом концерте.</span>
            </TildaB>
            <TildaB>
                <a id = "toConcertShort" href={calculateShortPageUrlNew(appdata)} target="_parent"
                   className="myButton myButtonYellow">{"На страницу концерта \"" + calcNameOfConcert(appdata)+ "\""}</a>
            </TildaB>
        </Container>
    </div>);
}

